import Allergy from './Allergy';
import PatientMemo from './PatientMemo';
import Precautions from './Precautions';

interface Props {
  coachRef?: any;
}

const PatientHandoverSection = ({ coachRef }: Props) => (
  <>
    <Allergy />
    <Precautions />
    <PatientMemo coachRef={coachRef} />
  </>
);

export default PatientHandoverSection;
